import apiClient from './client';

/**
 * GET /warehouses
 */
export async function listWarehouses() {
  const response = await apiClient.get('/warehouses');
  return response.data;
}

/**
 * GET /warehouses/{id}/stock — list of batches with stock at this warehouse.
 * Returns array of WarehouseStockItem (batch_id, product_name, available_qty, etc.).
 */
export async function listWarehouseStock(warehouseId) {
  const response = await apiClient.get(`/warehouses/${warehouseId}/stock`);
  return response.data;
}

/**
 * POST /warehouses/transfer
 *
 * Body: { batch_id, from_warehouse_id, to_warehouse_id, quantity, reason? }
 *
 * Backend:
 *   - Auth: get_current_user (any authenticated user — reps included).
 *   - Validation: source_warehouse_id !== to_warehouse_id (Pydantic
 *     model_validator throws 422 otherwise).
 *   - Service-level checks: source allocation must have enough
 *     available qty; otherwise 4xx with explanatory detail.
 *   - Side effects: decrements source.quantity_available, increments
 *     dest.quantity_available, writes a StockMovement ledger row.
 *
 * Returns { message, source: { warehouse_id, quantity_available },
 *           destination: { warehouse_id, quantity_available } }.
 */
export async function transferStock({
  batchId,
  fromWarehouseId,
  toWarehouseId,
  quantity,
  reason,
}) {
  const body = {
    batch_id:           batchId,
    from_warehouse_id:  fromWarehouseId,
    to_warehouse_id:    toWarehouseId,
    quantity,
  };
  if (reason != null && reason !== '') body.reason = reason;
  const response = await apiClient.post('/warehouses/transfer', body);
  return response.data;
}
